import * as React from 'react';
import { Props } from '../types/types';

import parse from 'html-react-parser';
import { Container, Row, Col } from 'react-bootstrap';
import { View, Icon, Text, rem, Touchable } from '../libs/WebComponents';

let totalHeight=0;
let top=0;

const QuestionRange = (props: Props) => {
   const [isValid, setIsValid] = React.useState(props.page.required ? false : true);
   const [isDragging, setIsDragging] = React.useState(false);
   const [moveY,setMoveY] = React.useState(-1);

   const _startMove = React.useCallback((e: any)=>{
      const boundary = e.target? e.target.getBoundingClientRect() : {height:0};
      totalHeight = boundary.height;
      top = boundary.top;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      let y = 100 - Math.ceil((clientY - top) / totalHeight * 100);
      if (y < 0) y = 0;
      if (y > 100) y = 100;
      setMoveY(y);
      setIsDragging(true);
   },[]);

   const _onMove = React.useCallback((e: any)=>{
      if (!isDragging) return;

      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      let y = 100 - Math.ceil((clientY - top) / totalHeight * 100);
      if (y < 0) y = 0;
      if (y > 100) y = 100;
      setMoveY(y);
   },[isDragging]);

   const _stopMove = React.useCallback((e: any)=>{
      setIsDragging(false);
      props.setAnswers({range_0_100:Number(moveY)});
      setIsValid(true);
   },[moveY, isDragging]);

   React.useEffect(()=>{
      props.setShowExplanationPage(()=>()=>props.showTip(props.page.question_type));
      return ()=>{
         props.setShowExplanationPage(null);
      }
   },[]);


   React.useEffect(()=>{
      if (props.given_answers && props.given_answers.range_0_100 && !Number.isNaN(props.given_answers.range_0_100))
      {
         setMoveY(props.given_answers.range_0_100);
         setIsValid(true);
      }
   },[props.given_answers]);

   return (
      <Container>
         <Row className={'justify-content-center'}>
            <Col className={'col-9 col-lg-8 offset-lg-1 col-xl-6'}>
               <View style={{margin: '3rem auto 3rem 0',maxWidth:500}}>
                  {props.page.image1 ? parse(props.page.image1): null}
               </View>
            </Col>
            <Col className={'col-3'} style={{position:'relative'}}>
               <View className={'range-selector-container'}>
                  <RangeSelector
                     onPressIn={_startMove}
                     onMove={_onMove}
                     onPressOut={isDragging?_stopMove:null}
                     moveY={moveY}
                  />
                  {moveY>-1?<Text style={{display:'block',textAlign:'center',width:'100%',fontWeight:'bold',fontSize:rem(1.2),color:'var(--color-green)'}}>{moveY}</Text>:null}
               </View>
            </Col>
         </Row>
      </Container>
   );
}

const RangeSelector = (props: Props) => {
   return (
      <View className={'range-selector'}>
         <View className={'filler'} style={{height: props.moveY + '%'}}/>
         <View style={{position:'absolute', top:rem(1), left:0, width:'100%', alignItems:'center'}}><Icon name={'EmoticonHappy'} size={rem(5)} color={props.moveY>90?'var(--color-white)':'var(--color-orange)'} /></View>
         <View style={{position:'absolute', bottom:rem(1), left:0, width:'100%', alignItems:'center'}}><Icon name={'EmoticonMad'} size={rem(5)} color={props.moveY>10?'var(--color-white)':'var(--color-orange)'} /></View>
         <Touchable className={'slide-canvas'}
         onMove={props.onMove} onPressIn={props.onPressIn} onPressOut={props.onPressOut} onMouseLeave={props.onPressOut} onPressCancel={props.onPressOut}
      />
      </View>
   )
};


export default React.memo(QuestionRange);